import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Trash2, Check } from "lucide-react";
import AdminLayout from "../components/AdminLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminMessages() {
  const [filter, setFilter] = useState("unread");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/admin/messages`, { params: filter ? { status: filter } : {}, withCredentials: true });
      setMessages(data);
    } catch { toast.error("Chargement impossible"); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [filter]);

  const markRead = async (id) => {
    try {
      await axios.post(`${API}/admin/messages/${id}/mark-read`, {}, { withCredentials: true });
      setMessages((prev) => prev.map((m) => m.id === id ? { ...m, read: true } : m));
    } catch { toast.error("Action impossible"); }
  };
  const del = async (id) => {
    if (!window.confirm("Supprimer ce message ?")) return;
    try {
      await axios.delete(`${API}/admin/messages/${id}`, { withCredentials: true });
      setMessages((prev) => prev.filter((m) => m.id !== id));
      toast.success("Supprimé");
    } catch { toast.error("Action impossible"); }
  };

  return (
    <AdminLayout current="messages">
      <div className="max-w-4xl" data-testid="admin-messages-page">
        <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
          <div>
            <p className="label-caps text-[color:var(--gold)] text-[10px] tracking-[0.3em] mb-2">Messagerie</p>
            <h1 className="font-serif text-4xl">Messages clients</h1>
          </div>
          <div className="flex gap-2">
            {[["unread", "Non lus"], ["read", "Lus"], ["", "Tous"]].map(([k, l]) => (
              <button key={k} onClick={() => setFilter(k)}
                data-testid={`msg-filter-${k || "all"}`}
                className={`px-4 py-2 label-caps text-[10px] tracking-[0.25em] border transition-colors ${
                  filter === k ? "border-[color:var(--gold)] text-[color:var(--gold)] bg-[color:var(--gold)]/5"
                  : "border-white/10 text-white/60 hover:text-white hover:border-white/30"
                }`}>{l}</button>
            ))}
          </div>
        </div>

        {loading && <p className="text-white/40">Chargement…</p>}
        {!loading && messages.length === 0 && (
          <div className="text-center py-20 border border-dashed border-white/10"><p className="text-white/50">Aucun message.</p></div>
        )}

        <div className="space-y-4">
          {messages.map((m) => (
            <div key={m.id} className={`border p-6 transition-colors ${m.read ? "border-white/10 hover:border-white/25" : "border-[color:var(--gold)]/30 bg-[color:var(--gold)]/5"}`} data-testid={`msg-${m.id.slice(0,8)}`}>
              <div className="flex items-start justify-between gap-4 mb-3 flex-wrap">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <p className="font-serif text-xl">{m.subject || "Sans objet"}</p>
                    {!m.read && <span className="label-caps text-[9px] bg-[color:var(--gold)] text-black px-2 py-0.5">Nouveau</span>}
                  </div>
                  <p className="text-white/50 text-xs">{m.name} · <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject || "")}`} className="text-[color:var(--gold)] hover:underline">{m.email}</a>{m.phone && ` · ${m.phone}`}</p>
                  <p className="text-white/30 text-[10px] mt-1">{m.created_at && new Date(m.created_at).toLocaleString("fr-FR")}</p>
                </div>
                <div className="flex gap-2 shrink-0">
                  {!m.read && (
                    <button onClick={() => markRead(m.id)} className="inline-flex items-center gap-1.5 border border-white/15 hover:border-[color:var(--gold)] text-white/70 hover:text-[color:var(--gold)] px-3 py-1.5 label-caps text-[10px]"><Check size={12} /> Marquer lu</button>
                  )}
                  <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject || "")}`} className="inline-flex items-center gap-1.5 bg-[color:var(--gold)] text-black hover:bg-white px-3 py-1.5 label-caps text-[10px]"><Mail size={12} /> Répondre</a>
                  <button onClick={() => del(m.id)} className="inline-flex items-center gap-1.5 border border-white/15 hover:border-red-400 text-white/40 hover:text-red-400 px-3 py-1.5"><Trash2 size={12} /></button>
                </div>
              </div>
              <p className="text-white/80 leading-relaxed whitespace-pre-wrap border-t border-white/5 pt-4 text-sm">{m.message}</p>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
